import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import ReceiveOfficialDoc from '@/types/table/receiveOfficialDoc';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface ReceiveOfficialDocData extends ReceiveOfficialDoc {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class ReceiveOfficialDocController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<ReceiveOfficialDocData>>(
      API_CONTEXT + '/upms/receiveOfficialDoc/list',
      params,
      httpOptions,
    );
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<ReceiveOfficialDocData>(
      API_CONTEXT + '/upms/receiveOfficialDoc/view',
      params,
      httpOptions,
    );
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/receiveOfficialDoc/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/receiveOfficialDoc/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/receiveOfficialDoc/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/receiveOfficialDoc/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/receiveOfficialDoc/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/receiveOfficialDoc/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/receiveOfficialDoc/deleteBatch', params, httpOptions);
  }
  static startOnlyAuditReceiveOfficialDoc(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/receiveOfficialDoc/startOnly/auditOfficialDocReceive',
      params,
      httpOptions,
    );
  }
  static startWithBusinessKeyAuditReceiveOfficialDoc(
    params: ANY_OBJECT,
    httpOptions?: RequestOption,
  ) {
    return super.post(
      API_CONTEXT + '/upms/receiveOfficialDoc/startWithBusinessKey/auditOfficialDocReceive',
      params,
      httpOptions,
    );
  }
  static startAndTakeUserTaskAuditReceiveOfficialDoc(
    params: ANY_OBJECT,
    httpOptions?: RequestOption,
  ) {
    return super.post(
      API_CONTEXT + '/upms/receiveOfficialDoc/startAndTakeUserTask/auditOfficialDocReceive',
      params,
      httpOptions,
    );
  }
  static startAndSaveDraftAuditReceiveOfficialDoc(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/receiveOfficialDoc/startAndSaveDraft/auditOfficialDocReceive',
      params,
      httpOptions,
    );
  }
  static submitUserTaskAuditReceiveOfficialDoc(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/receiveOfficialDoc/submitUserTask/auditOfficialDocReceive',
      params,
      httpOptions,
    );
  }
  static viewTaskBusinessDataAuditReceiveOfficialDoc(
    params: ANY_OBJECT,
    httpOptions?: RequestOption,
  ) {
    return super.get(
      API_CONTEXT + '/upms/receiveOfficialDoc/viewTaskBusinessData/auditOfficialDocReceive',
      params,
      httpOptions,
    );
  }
  static viewHistoricTaskBusinessDataAuditReceiveOfficialDoc(
    params: ANY_OBJECT,
    httpOptions?: RequestOption,
  ) {
    return super.get(
      API_CONTEXT + '/upms/receiveOfficialDoc/viewHistoricTaskBusinessData/auditOfficialDocReceive',
      params,
      httpOptions,
    );
  }
  static listWorkOrderAuditReceiveOfficialDoc(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(
      API_CONTEXT + '/upms/receiveOfficialDoc/listWorkOrder/auditOfficialDocReceive',
      params,
      httpOptions,
    );
  }
}
